import { MoreVertical, Pencil, Unlink } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shared/components/ui/shadcn/dropdown-menu';
import type { ShipmentStatusMapping } from '../../models/shipmentStatusMapping.types';

interface DropdownActionsProps {
  mapping: ShipmentStatusMapping;
  onEdit: () => void;
  onUnmap: () => void;
}

export const DropdownActions = memo(function DropdownActions({ mapping, onEdit, onUnmap }: DropdownActionsProps) {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          data-testid={`mapping-actions-${mapping.id}`}
          aria-label={t('shipmentStatusMapping.table.actions')}
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit}>
          <Pencil className="mr-2 h-4 w-4" />
          {mapping.shipment_status ? t('shipmentStatusMapping.actions.edit') : t('shipmentStatusMapping.actions.map')}
        </DropdownMenuItem>

        {mapping.shipment_status && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onUnmap} className="text-destructive focus:text-destructive">
              <Unlink className="mr-2 h-4 w-4" />
              {t('shipmentStatusMapping.actions.unmap')}
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
});
